import { Component } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { ToasterService, Toast } from './toaster.service';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-toaster',
  standalone: true,
  imports: [NgClass, AsyncPipe],
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent {
  showToast(arg0: string, arg1: string) {
    throw new Error('Method not implemented.');
  }
  toasts$: Observable<Toast[]>;

  constructor(private toasterService: ToasterService) {
    this.toasts$ = this.toasterService.getToasts();
  }

  dismiss(id: number): void {
    this.toasterService.removeToast(id);
  }
}
